import { render, staticRenderFns } from "./MobilePackageRenewal.vue?vue&type=template&id=c2166e74&scoped=true&"
import script from "./MobilePackageRenewal.vue?vue&type=script&lang=js&"
export * from "./MobilePackageRenewal.vue?vue&type=script&lang=js&"
import style0 from "./MobilePackageRenewal.vue?vue&type=style&index=0&id=c2166e74&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2166e74",
  null
  
)

export default component.exports